// Dipende da src/components/animations/useScrollPin.js del progetto (stack scroll-experience).
import { useHorizontalScroll } from '@/components/animations/useScrollPin';
import { SlideMedia } from './SlideMedia';

/**
 * Scroll-jacking orizzontale: pannelli affiancati che scorrono in orizzontale.
 * Ogni pannello può avere un media (immagine o video) di sfondo e una CTA,
 * oltre al titolo — `showOverlay` disattiva testo e scrim insieme, per un
 * pannello puramente visivo.
 * @param {{ panels?: Array<{ mediaType?: 'image'|'video', image?: string, imageAlt?: string, videoUrl?: string, showOverlay?: boolean, title: string, ctaLabel?: string, ctaHref?: string }> }} props
 */
export function HorizontalScrollBlock({ panels = [] }) {
  const ref = useHorizontalScroll();
  return (
    <section ref={ref} className="h-screen overflow-hidden bg-theme-bg">
      <div className="flex h-full w-max">
        {panels.map((panel, i) => {
          // Retrocompatibilità: pannelli salvati come semplice stringa prima di questo aggiornamento.
          const p = typeof panel === 'string' ? { title: panel } : panel;
          const hasMedia = p.mediaType === 'video' ? !!p.videoUrl : !!p.image;
          const showOverlay = p.showOverlay !== false;
          return (
            <div key={i} className="relative w-screen h-full flex flex-col items-center justify-center gap-5 text-center px-6 border-r border-theme-border overflow-hidden">
              {hasMedia && (
                <>
                  <SlideMedia
                    mediaType={p.mediaType}
                    image={p.image}
                    imageAlt={p.imageAlt}
                    videoUrl={p.videoUrl}
                    fallbackAlt={p.title}
                    className="-z-10"
                  />
                  {showOverlay && <div className="absolute inset-0 bg-black/35 -z-10" />}
                </>
              )}
              {/* h2 fisso: questo blocco non ha un titolo di sezione proprio (vedi
                  registry.js, nessun headingField) quindi non compete mai per
                  l'H1 di pagina — resta sempre a un livello sicuro. */}
              {showOverlay && (
                <>
                  <h2 className={'font-heading text-h2 font-light ' + (hasMedia ? 'text-white' : 'text-theme-text')}>{p.title}</h2>
                  {p.ctaLabel && (
                    <a
                      href={p.ctaHref || '#'}
                      className="inline-flex items-center px-6 py-2.5 rounded-lg bg-theme-accent text-theme-accent-text text-sm font-medium tracking-wide"
                    >
                      {p.ctaLabel}
                    </a>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
